export default __webpack_public_path__ + "static/media/barkley.ceb35ece.png";